import firebase from 'firebase'
import Auth from "@/modules/auth/auth.js";

export const setLoginData = ({ commit },data) => {
    commit('LOGIN_DATA', data);
}

export const refreshLoginData = ({ commit }) => {
    return new Promise((resolve, reject) => {
        if(firebase.auth().currentUser){
            firebase.auth().currentUser.getIdToken().then(function(idToken) {
                Auth.loginWithFirebaseAccessToken(idToken)
                    .then(response => {
                        console.log(response)
                        // if(response.data.name==''){
                        //   dispatch('signOut')
                        // }
                        commit('LOGIN_DATA', response.data);
                        resolve(response.data)
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e);
                    })
              }).catch(function(error) {
                console.log(error)
                reject(error);
              });
        } else {
            //reject(new Error('session expired'));
        }
    });
}

export const signOut = ({commit}) => {
    firebase.auth()
        .signOut()
        .then(() => {
            commit('LOGIN_DATA', null);
            window.location.reload();
        })
        .catch(
            error => {
                console.log(error.message);
            }
        );
}


export const signInWithUsernamePassword = ({commit},data) => {
    return new Promise((resolve, reject) => {
        Auth.loginWithUsernamePassword(data.username,data.password)
            .then(response => {
                firebase.auth()
                  .signInWithEmailAndPassword(data.username,data.password)
                  .then(() => {
                     commit('LOGIN_DATA', response.data);
                     resolve(response.data)
                  })
                  .catch(err => {
                    reject(err)
                  });
            })
            .catch(err => {
                reject(err);
            });
    });
}

export const signInWithFacebook = ({dispatch, commit}) => {
    return new Promise((resolve, reject) => {
      commit('LINK_CREDENTIAL', null);

      const provider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
            dispatch('refreshLoginData')
                .then((data)=>{
                  resolve(data)
                })
                .catch(error=>{
                  reject({
                    err_code: error.code,
                    error: error,
                  })
                });
        })
        .catch(err => {
          if (err.code === 'auth/account-exists-with-different-credential') {
            dispatch('onAccountExistsWithDifferentCredential',[err])
                .then((data)=>{
                  resolve(data)
                })
                .catch(error=>{
                  reject(error)
                });
          } else {
            reject({
              err_code: err.code,
              error: err,
            })
          }
        });
    });
}

export const signInWithGoogle = ({dispatch, commit}) => {
    return new Promise((resolve, reject) => {
      commit('LINK_CREDENTIAL', null);


      const provider = new firebase.auth.GoogleAuthProvider();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
            dispatch('refreshLoginData')
                .then((data)=>{
                  resolve(data)
                })
                .catch(error=>{
                  reject({
                    err_code: error.code,
                    error: error,
                  })
                });
        })
        .catch(err => {
          if (err.code === 'auth/account-exists-with-different-credential') {
            dispatch('onAccountExistsWithDifferentCredential',[err])
                .then((data)=>{
                  resolve(data)
                })
                .catch(error=>{
                  reject(error)
                });
          } else {
            reject({
              err_code: err.code,
              error: err,
            })
          }
        });
    });
}

export const signInWithApple = ({dispatch, commit}) => {
    return new Promise((resolve, reject) => {
      commit('LINK_CREDENTIAL', null);

      const provider = new firebase.auth.OAuthProvider('apple.com');
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(() => {
            dispatch('refreshLoginData')
                .then((data)=>{
                  resolve(data)
                })
                .catch(error=>{
                  reject({
                    err_code: error.code,
                    error: error,
                  })
                });
        })
        .catch(err => {
          if (err.code === 'auth/account-exists-with-different-credential') {
            dispatch('onAccountExistsWithDifferentCredential',[err])
                .then((data)=>{
                  resolve(data)
                })
                .catch(error=>{
                  reject(error)
                });
          } else {
            reject({
              err_code: err.code,
              error: err,
            })
          }
        });
    });
}

export const onAccountExistsWithDifferentCredential = ({commit}, [err]) => {
  return new Promise((resolve, reject) => {
    // The pending provider credential.
    let pendingCred = err.credential;
    // The provider account's email address.
    let email = err.email;
    // Get the sign-in methods for this email.
    firebase.auth().fetchSignInMethodsForEmail(email).then(methods => {
      // If the user has several sign-in methods, the first method in the list will be the "recommended" method to use.
      let linkCredential = {
        method: methods[0],
        pendingCred: pendingCred,
        email: email,
        err_code: err.code,
        error: err,
        provider: methods[0] === 'password' ? '' : /(.*)\.com/g.exec(methods[0])[1]
      }
      commit('LINK_CREDENTIAL', linkCredential);
      reject(linkCredential);
      return;
    })
    .catch(err => {
      reject(err)
    });
  });
}

export const linkCredentialUsingProvider = ({dispatch, commit, state}) => {
  return new Promise((resolve, reject) => {
    let linkCredential = state.linkCredential;
    if(linkCredential && linkCredential.email && linkCredential.method && linkCredential.pendingCred) {
      // Construct provider object for that provider.
      let provider = new firebase.auth.OAuthProvider(linkCredential.method);
      firebase.auth().signInWithPopup(provider).then(result => {
        if(result.additionalUserInfo.profile.email === linkCredential.email) {
          result.user.linkWithCredential(linkCredential.pendingCred).then(usercred => {
            console.log(usercred);
            dispatch('refreshLoginData')
                    .then((data)=>{
                      resolve(data)
                    })
                    .catch(error=>{
                      reject(error)
                    });
          });
        } else {
          firebase.auth()
          .signOut()
          .then(() => {
              commit('LOGIN_DATA', null)
          })
          .catch(
              error => {
                  console.log(error.message);
              }
          );

          reject({
            err_code: '',
            error: {
              message:'Link failed. You have not loged in using <b>'+linkCredential.email+'</b>!'
            },
          })
        }
      })
      .catch(err => {
        reject({
          err_code: err.code,
          error: err,
        })
      });
    } else {
      reject({
        err_code: '',
        error: {
          message:'Link with credential failed.'
        },
      })
    }
  });
}

export const linkCredentialUsingPassword = ({dispatch,state}, [password]) => {
  return new Promise((resolve, reject) => {
    let linkCredential = state.linkCredential;
    if(linkCredential && linkCredential.email && password && linkCredential.pendingCred) {
      firebase.auth().signInWithEmailAndPassword(linkCredential.email, password).then(result => {
        result.user.linkWithCredential(linkCredential.pendingCred).then(usercred => {
          console.log(usercred);
          dispatch('refreshLoginData')
                  .then((data)=>{
                    resolve(data)
                  })
                  .catch(error=>{
                    reject(error)
                  });
        });
      }).catch(err => {
        reject({
          err_code: err.code,
          error: err,
        })
      });
    } else {
      reject({
        err_code: '',
        error: {
          message:'Link with credential failed.'
        },
      })
    }
});
}